export default {
    data: () => ({
        timeout: null
    }),
    methods: {
        debounce: function(fn, delay) {
            if (this.timeout) {

                clearTimeout(this.timeout);
            }

            this.timeout = setTimeout(() => {
                fn()
            }, delay);
        },
    }
}